import React, { Component } from 'react';
import { Drawer, Button } from '@blueprintjs/core';
import {
	DrawerHeader,
	PlainButton,
	Table,
	TableHeader,
	TableData,
	Container
} from 'components/styled-components';
import { IconNames } from '@blueprintjs/icons';
import colors from 'utils/colors';
import cloneDeep from 'lodash/cloneDeep';
import Select from 'react-select';
import {
	HeaderControls,
	ScrollWrapper,
	TableRow,
	Wrapper
} from 'containers/Manage-Questionnaire/styled-components';
import Loading from 'components/loading';

class QuestionReorderDrawer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			displayCategory: null,
			questionType: null
		};
		this.state.list = this.updateList(); //need to do this after so we have access to state
	}

	componentDidUpdate(prevProps){
		if(
			(JSON.stringify(prevProps.list) !== JSON.stringify(this.props.list))
			|| (prevProps.isOpen === false && this.props.isOpen === true)
		){
			this.updateList();
		}
	}

	updateList = () => {
		const { displayCategory, questionType } = this.state;
		const newList = cloneDeep(this.props.list)
		.filter((item, itemKey) => item.questionTypeID === questionType && item.displayCategoryID === displayCategory )
		.map((item, itemKey) => { // cleanup the 999 ordering
			if(item.displayOrder === 999){
				item.displayOrder = itemKey + 1;
			}
			return item;
		})

		this.setState({list: newList});

		return newList;
	}

	handleCloseDrawer = () => {
		// handle any local 'cleanup' before we use the parent's method for closing the drawer
		this.props.closeDrawer();
	};

	handleSaveOrder = () => {
		const updatedList = cloneDeep(this.state.list);
		this.props.handleSaveOrder(updatedList);
	}

	handleChangeOrder = (value, key) => {
		const previousOrder = this.state.list[key].displayOrder;
		const newOrder = value.value;
		
		let newList = cloneDeep(this.state.list)
							.map(item => { //re-order the rest of the list
								if(newOrder < previousOrder){
									if(item.displayOrder >= newOrder && item.displayOrder < previousOrder){
										item.displayOrder = item.displayOrder + 1;
									}
								}else{
									if(item.displayOrder <= newOrder && item.displayOrder > previousOrder){
										item.displayOrder = item.displayOrder - 1;
									}
								}
								return item;
							})

		newList[key].displayOrder = value.value;
		this.setState({list: newList});
	}

	setDisplayCategory = (selection) => {
		this.setState({displayCategory: selection.value}, () => {
			this.updateList();
		});
	}

	setQuestionType = (selection) => {
		this.setState({questionType: selection.value}, () => {
			this.updateList();
		});
	}

	render() {
		const { isOpen, isLoading, displayCategories, questionTypes } = this.props;
		const { list, displayCategory, questionType } = this.state;

		if(isLoading)
			return (
				<Drawer isOpen={isOpen} onClose={this.handleCloseDrawer}>
					<DrawerHeader>
						Re-order Questions
						<HeaderControls>
							<Button icon={IconNames.CROSS} onClick={this.handleCloseDrawer} minimal />
						</HeaderControls>
					</DrawerHeader>
					<ScrollWrapper>
						<Loading size={100} />
					</ScrollWrapper>
				</Drawer>
			);

		return (
			<Drawer isOpen={isOpen} onClose={this.handleCloseDrawer}>
				<DrawerHeader>
					Re-order Questions
					<HeaderControls>
						<Button icon={IconNames.CROSS} onClick={this.handleCloseDrawer} minimal />
					</HeaderControls>
				</DrawerHeader>
				<ScrollWrapper>
					<div style={{display: "flex", justifyContent: "space-between", gap: "20px", marginBottom: "20px"}}>
						<div style={{flex: "1 1 100%"}}>
							<label htmlFor="questionType">Question Type</label>
							<Select
								name="questionType"
								onChange={(selection) => this.setQuestionType(selection)}
								value={questionTypes.filter(qt => qt.typeID === questionType).map(qt => {
									return { label: qt.typeName, value: qt.typeID };
								})}
								options={questionTypes.map(qt => {
									return { label: qt.typeName, value: qt.typeID };
								})}
							/>
						</div>
						<div style={{flex: "1 1 100%"}}>
							<label htmlFor="displayCategory">Display Category</label>
							<Select
								name="displayCategory"
								onChange={(selection) => this.setDisplayCategory(selection)}
								value={displayCategories.filter(dc => dc.categoryID === displayCategory).map(dc => {
									return { label: dc.categoryName, value: dc.categoryID };
								})}
								options={displayCategories.map(dc => {
									return { label: dc.categoryName, value: dc.categoryID };
								})}
							/>
						</div>
					</div>
					<Container background={colors.whiteGray} width="95%">
						<Wrapper>
							<Table>
								<tbody>
									<TableRow>
										<TableHeader>Questionnaire Question</TableHeader>
										<TableHeader>Order</TableHeader>
									</TableRow>
									{list.map((psq, pskey) => {

										return (
											<TableRow key={`prscreen-reorder-${pskey}`}>
												<TableData>{psq.question}</TableData>
												<TableData style={{"minWidth": "200px"}}>
													<Select
														onChange={(thing) => this.handleChangeOrder(thing, pskey)}
														value={{ label: psq.displayOrder, value: psq.displayOrder }}
														options={list.map((v,k) => {
															return { label: k+1, value: k+1 };
														})}
													/>
												</TableData>
											</TableRow>
										)
									})}
								</tbody>
							</Table>
						</Wrapper>
					</Container>
					{list.length < 1 ? "" :
						<PlainButton style={{marginLeft: "0", display: "block", marginBottom: "1rem"}} onClick={this.handleSaveOrder}>Save Order</PlainButton>
					}
				</ScrollWrapper>
			</Drawer>
		);
	}
}

export default QuestionReorderDrawer;